<template>
    <div v-if="showVerticalMenu" id="vMenu">
        <b-list-group-item
            :href="menuRoutes['balance-global']"
            class="item"
            :active="pageName === 'balance-global'"
            @click="setPageName('balance-global')"
        >
            <i class="fa-fw fal fa-table menu-sub-icon"></i>Global
        </b-list-group-item>
        <b-list-group-item
            :href="menuRoutes['balance-user']"
            class="item"
            :active="pageName === 'balance-user'"
            @click="setPageName('balance-user')"
        >
            <i class="fa-fw fal fa-user-friends menu-sub-icon"></i>Par
            collaborateur
        </b-list-group-item>
        <b-list-group-item
            :href="menuRoutes['balance-state']"
            class="item"
            :active="pageName === 'balance-state'"
            @click="setPageName('balance-state')"
        >
            <i class="fa-fw fal fa-project-diagram menu-sub-icon"></i>Par état
        </b-list-group-item>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'BalanceDashboardVerticalMenu',

    props: {
        page: '',
    },

    data() {
        return {
            openBalance: false,
            activeBalance: '',
        }
    },

    async created() {
        await this.$store.dispatch('dashboardVM/getRoutes')
        this.$store.commit('dashboardVM/SHOW_VERTICAL_MENU')
        this.handleBalanceMenu()
    },

    methods: {
        setPageName(pageName) {
            this.$store.commit('browsing/SET_PAGE_NAME', pageName)
        },
        handleBalanceMenu() {
            this.openBalance = [
                'balance-global',
                'balance-user',
                'balance-state',
            ].includes(this.page)
            this.activeBalance = this.openBalance ? 'active' : ''
        },
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
            showVerticalMenu: (state) => state.dashboardVM.showVerticalMenu,
            menuRoutes: (state) => state.dashboardVM.menuRoutes,
        }),
    },
}
</script>

<style scoped></style>
